import { Pill, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";
import { useHistory } from "react-router-dom";

import { AccountOnHoldCallout } from "../../Charting/AccountOnHoldCallout";
import { CLIPBOARD_SCORE_FULL_PATH } from "../../ClipboardScore/utils/paths";
import { Button } from "../../components/Button";
import { getSafeAreaPaddings } from "../../utils/getSafeAreaPaddings";
import { ListViewBanners } from "../ListView/Banners";
import { WorkerReferralCta } from "../ListView/WorkerReferralCta";
import { WorkplaceReferralCta } from "../ListView/WorkplaceReferralCta";

interface RestrictedPageContentProps {
  liftDate?: string;
  onRefresh: () => Promise<void>;
}

export function RestrictedPageContent(props: RestrictedPageContentProps) {
  const { liftDate, onRefresh } = props;
  const history = useHistory();

  const handleCtaClick = () => {
    history.push(CLIPBOARD_SCORE_FULL_PATH);
  };

  return (
    <Stack
      flex={1}
      overflow="hidden"
      position="relative"
      sx={{
        ...getSafeAreaPaddings({
          top: true,
          bottom: true,
        }),
        background: "linear-gradient(353deg, #FBF2E8 37.36%, #F7D0D0 111.62%)",
      }}
    >
      <PullToRefresh onRefresh={onRefresh} />

      <AccountOnHoldCallout />

      <Box sx={{ pt: 5 }}>
        <ListViewBanners showClipboardScoreBanner={false} />
      </Box>

      <Box sx={{ flex: "1", overflow: "auto", pb: 10 }}>
        <Stack flex={1} spacing={5} p={5} pt={10} alignItems="center">
          {isDefined(liftDate) && (
            <Pill
              iconType="clock-filled"
              label={`Lifts on ${liftDate}`}
              size="small"
              sx={{ display: "inline-flex", backgroundColor: "rgba(255, 255, 255, 0.4)" }}
            />
          )}

          <Text variant="h2" textAlign="center" color={(theme) => theme.palette.error.main}>
            Your account is Restricted
          </Text>

          <Text
            variant="body2"
            textAlign="center"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            Your Clipboard Score reached zero as a result of cancellations or late arrivals. As a
            result, you&apos;re temporarily unable to book open shifts.
          </Text>

          <Button variant="outlined" size="medium" onClick={handleCtaClick}>
            Learn More
          </Button>

          <Stack spacing={3} sx={{ pt: 8, width: "100%" }}>
            <WorkerReferralCta />
            <WorkplaceReferralCta />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
